import React from 'react';
import { themeColor } from '../../../utils/themeColor';
import { BROKER_BRAND, resolveBrokerKey } from '../../vectorDashboard/brokerBranding';
import { brokerLabel } from './myDataApi';

/* Formatting and broker marks shared by the "My accounts" widgets and their detail views. */

export const usd = (n, { sign = false, cents = false, compact = false } = {}) => {
  const v = Number(n) || 0;
  if (compact && Math.abs(v) >= 10000) {
    const s = Math.abs(v).toLocaleString('en-US', { style: 'currency', currency: 'USD', notation: 'compact', maximumFractionDigits: 1 });
    return `${sign && v > 0 ? '+' : v < 0 ? '-' : ''}${s}`;
  }
  // Small amounts (a $1.37 crypto balance) keep their cents; big ones round to dollars.
  const digits = cents || (Math.abs(v) > 0 && Math.abs(v) < 100) ? 2 : 0;
  const s = Math.abs(v).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: digits });
  if (!sign) return v < 0 ? `-${s}` : s;
  return `${v > 0 ? '+' : v < 0 ? '-' : ''}${s}`;
};
export const pct = (n, { sign = true } = {}) => {
  if (n == null || !Number.isFinite(n)) return '—';
  const v = n * 100;
  return `${sign && v > 0 ? '+' : ''}${v.toFixed(Math.abs(v) < 10 ? 2 : 1)}%`;
};
export const tone = (n) => (n > 0 ? 'is-up' : n < 0 ? 'is-down' : '');
export const shortDate = (d) => {
  const [y, m, day] = String(d || '').split('-');
  return y ? `${m}/${day}` : d;
};
export const niceDate = (d) => {
  const t = new Date(`${String(d).slice(0, 10)}T12:00:00`);
  return Number.isNaN(t.getTime()) ? String(d || '') : t.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
};
export const rangeLabel = (r) => ({ '1M': 'this month', '3M': 'last 3 months', '6M': 'last 6 months', YTD: 'year to date', '1Y': 'last year', All: 'all time' }[r] || r);

export const UP = '#22c55e';
export const DOWN = '#ef4444';
const BASE_PALETTE = ['#667eea', '#22c55e', '#f59e0b', '#ec4899', '#06b6d4', '#a78bfa', '#f87171', '#84cc16'];
// The purples follow the brand theme; the other series colors stay distinct.
export const PALETTE = new Proxy(BASE_PALETTE, { get: (arr, k) => (typeof arr[k] === 'string' && /^\d+$/.test(String(k)) ? themeColor(arr[k]) : arr[k]) });

export function brandFor(broker, name) {
  const key = resolveBrokerKey(name, broker);
  return key ? BROKER_BRAND[key] : null;
}

/** Broker logo on a white tile, or a colored initial. */
export function BrokerMark({ broker, name, size = 22 }) {
  const brand = brandFor(broker, name);
  const label = brokerLabel(broker);
  return (
    <span className={`mydw-mark${brand?.logoSrc ? ' has-logo' : ''}`} style={{ width: size, height: size, background: brand?.logoSrc ? '#fff' : (brand?.color || '#6366f1') }} aria-hidden="true">
      {brand?.logoSrc ? <img src={brand.logoSrc} alt="" /> : String(label).charAt(0)}
    </span>
  );
}
